import React, {useEffect, useState} from "react";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import Slide from "@material-ui/core/Slide";
import {DEFAULT_OFFER_DESCRIPTION, DEFAULT_OFFER_DISCLAIMER, DEFAULT_OFFER_TITLE} from "../../../shared/constantsEN";
import tireOfferService from "../../../shared/services/tireOfferService";
import Container from "@material-ui/core/Container";

const transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function Offer() {
    const [promotionTitle, setPromotionTitle] = useState(DEFAULT_OFFER_TITLE.toUpperCase());
    const [promotionDescription, setPromotionDescription] = useState(DEFAULT_OFFER_DESCRIPTION);
    const [promotionDisclaimer, setPromotionDisclaimer] = useState(DEFAULT_OFFER_DISCLAIMER);
    const [open, setOpen] = useState(false);
    const [reLoad,setReLoad] = useState(true);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const parseText = (text) => {
        let parsed = "";
        if (text) {
            parsed = text.replace(/\{100}/g, '$100 Mail-in Rebate');
            parsed = parsed.replace(/\{200}/g, 'UP TO $200');
            parsed = parsed.replace(/{D}/g, String.fromCharCode(8224) + String.fromCharCode(8224));
            parsed = parsed.replace(/{SD}/g, String.fromCharCode(8224));
            parsed = parsed.replace(/{T}/g, String.fromCharCode(9651));
        }
        return parsed;
    };

    const setMessage = (data) => {
        let title = '';
        let description = '';
        let disclaimer = '';

        data.forEach((element) => {
            title += parseText(element.offerName) + '\n';
            description += parseText(element.offerDescription) + '\n';
            disclaimer += parseText(element.offerFinePrint) + '\n';
        });
        setPromotionTitle(title);
        console.log(promotionTitle);
        setPromotionDescription(description);
        setPromotionDisclaimer(disclaimer);
    };

    const getPromotionData = () => {
        tireOfferService.getCurrent().then(response => {
            const data = response.data;
            if (!Array.isArray(data) || data.length !== 0) {
                setMessage(data);
            }else if(data.length === 0){
                setReLoad(false);
            }
        }).catch(err => {
            if (err.response) {
                // client received an error response (5xx, 4xx)
                console.log(err.response);
            } else if (err.request) {
                // client never received a response, or request never left
                console.log(err.request);
            } else {
                // anything else
                console.log(err);
            }
        })
    };

    useEffect(() => {
        if(reLoad){
            getPromotionData();
        }
    });

    return (
        <>
            <div className={'hide-on-mobile'}>
                <div className={'headerStyles'}>
                    <div className={'headerAlignment'}>
                        <div className={'offerText'}>{promotionTitle}</div>
                        <Button className={'gds-button-tertiary stat-text-link'} data-dtm={"price match guarantee"}
                                color="inherit"
                                onClick={handleClickOpen}>
                            <u>Learn More</u>
                        </Button>
                    </div>
                    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={transition}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                <CloseIcon/>
                            </IconButton>
                        </Toolbar>
                        <Container maxWidth="lg">
                            <Typography variant="h2" gutterBottom>{promotionTitle}</Typography>
                            <Typography variant="body1" gutterBottom>{promotionDescription}</Typography>
                            <Typography variant="body2" gutterBottom>{promotionDisclaimer}</Typography>
                        </Container>
                    </Dialog>
                </div>
            </div>
            <div className={'hide-on-desktop'}>
                <div className={'headerStyles'}>
                    <div className={'offerAlignment'}>
                        <div className={'offerText'}>{promotionTitle}</div>
                    </div>
                    <div className={'buttonAlignment'}>
                        <Button className={'gds-button-tertiary stat-text-link'} data-dtm={"price match guarantee"}
                                color="inherit"
                                onClick={handleClickOpen}>
                            <u>Learn More</u>
                        </Button>
                    </div>
                    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={transition}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                <CloseIcon/>
                            </IconButton>
                        </Toolbar>
                        <Container maxWidth="lg">
                            <Typography variant="h4" gutterBottom>{promotionTitle}</Typography>
                            <Typography variant="body1" gutterBottom>{promotionDescription}</Typography>
                            <Typography variant="body2" gutterBottom>{promotionDisclaimer}</Typography>
                        </Container>
                    </Dialog>
                </div>
            </div>
        </>
    )
}

